'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaSlack = function FaSlack(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35.4 17.3q1.4 0 2.3 0.9t0.9 2.3q0 2.2-2 2.9l-3.9 1.3 1.3 3.7q0.1 0.5 0.1 1.1 0 1.3-0.9 2.3t-2.3 0.9q-1 0-1.9-0.6t-1.2-1.6l-1.2-3.7-6.9 2.4 1.2 3.7q0.2 0.5 0.2 1 0 1.3-0.9 2.3t-2.3 0.9q-1.1 0-1.9-0.6t-1.2-1.6l-1.2-3.6-3.4 1.2q-0.7 0.2-1.2 0.2-1.3 0-2.2-0.9t-0.9-2.3q0-1 0.6-1.9t1.6-1.1l3.5-1.2-2.4-7-3.5 1.2q-0.5 0.2-1 0.2-1.4 0-2.3-0.9t-0.9-2.3q0-1 0.6-1.9t1.6-1.2l3.5-1.1-1.2-3.6q-0.1-0.5-0.1-1 0-1.4 0.9-2.3t2.3-1q1 0 1.9 0.6t1.1 1.6l1.3 3.6 6.9-2.3-1.2-3.6q-0.2-0.5-0.2-1.1 0-1.3 0.9-2.2t2.3-1q1.1 0 1.9 0.6t1.2 1.6l1.2 3.6 3.6-1.2q0.5-0.2 1-0.2 1.3 0 2.3 0.9t0.9 2.2q0 1-0.7 1.8t-1.6 1.2l-3.5 1.2 2.3 7.1 3.7-1.3q0.5-0.2 1-0.2z m-17.7 5.9l6.9-2.4-2.3-7-7 2.4z' })
        )
    );
};

exports.default = FaSlack;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/slack.js
// module id = 1633
// module chunks = 0